<template lang="pug">
  div
    page_header(title="Corporate", subhead="Overview")
      router-link.btn.btn-primary.ml-3.d-none.d-sm-inline-block(:to='{name: "corporate.create", params:{id:id}}')
        i.feather-plus
        | Create New

    .row
      .col-sm-12
        card_table(
          ref="table"
          :url="$backend+'/admin/corporate'"
          :fields="columns"
          :token="user.token"
          :actions="actions"
          :class="sending?'loading':''"
          @edit="edit"
          @delete="delete_item"
          @export="exportData"
        )
        
    #confirm.modal.modal-blur.fade(tabindex='-1' role='dialog' style='display: none;' aria-hidden='true')
      .modal-dialog.modal-sm.modal-dialog-centered(role='document')
        .modal-content
          button.close(type='button' data-dismiss='modal' aria-label='Close')
            i.feather-x
          .modal-body.py-5
            form_input(type="text" name="sheet_url" label="Google Sheet Url" placeholder="Google Sheet Url" v-model="sheet_url" )  
            
            p Before proceeding Share sheet with
            p.m-0 
              b cross-sell@cross-sell-280112.iam.gserviceaccount.com

          .modal-footer
            button.btn.btn-red.btn-block(:disabled='sending' @click="exportdb")
              .spinner-border.spinner-border-sm.mr-2(v-if='sending')
              | Proceed
            a.btn.btn-secondary.btn-block(href='#' data-dismiss='modal')
              | Cancel


</template>

<script>
import page_header from '@/components/pageHeader'
import loading_button from '@/components/loadingBtn'
import card_table from '@/components/tables/card-table'
import form_input from '@/components/formInput'

import { mapActions, mapState } from 'vuex'

export default {
  name: 'Corporate',
  components: {
    page_header,
    loading_button,
    form_input,
    card_table
  },
  data(){
    return {
      selected_id:'',
      sheet_url: '',
      actions: [
        {
          name: 'export',
          type: 'icon',
          class: 'feather-external-link'
        },
        {
          name: 'edit',
          type: 'icon',
          class: 'feather-edit'
        },
        {
          name: 'delete',
          type: 'icon',
          class: 'feather-trash'
        }
      ],
      columns :[
        {
          name: 'name',
          sortField: 'name',
          title: "Name"
        },
        // {
        //   name: 'type',
        //   title: 'Type'
        // },
        {
          name: 'status',
          sortField: 'status',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center',
        }

      ],
    }
  },
  computed:{
    ...mapState('auth', ['user']),
    ...mapState('api', ['errors', 'sending'])
  },
  methods:{
    edit(data){
      this.$router.push({name: 'corporate.edit', params: {id: data.id}})
    },
    delete_item(data){
      var vm = this;
      if(confirm('Are you sure?')){
        this.call({_vm: this, endpoint:'admin/corporate/'+data.id, method: 'DELETE'}).then(()=>{
          vm.$refs.table.refreshTable();
        })
      }
    },
    exportData(data){
      this.selected_id = data.id
      $('#confirm').modal('show')
    },
    exportdb(){
      var vm = this;
      this.call({ _vm: this, endpoint:'admin/challenge/'+this.selected_id+"/export", method: 'POST', data:{sheet_url: this.sheet_url} })
        .then(function(){
          $('#confirm').modal('hide')
          vm.selected_id = '';
        });
    },
    ...mapActions('api', ['call'])
  }

}
</script>